import React from 'react';
import '../App.css';

const StatisticsBar = () => {
  return (
    <div className="about-stats" role="region" aria-label="Company statistics">
      <div className="stat-item" aria-label="Strategic Partners">
        <div className="stat-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="42" height="42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="stat-number">8</div>
        <div className="stat-label">Strategic Partners</div>
      </div>
      <div className="stat-item" aria-label="Joint Projects">
        <div className="stat-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="42" height="42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 16h2l1 3h12l1-3h2M5 16V7h6l2 3h6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="stat-number">1000+</div>
        <div className="stat-label">Joint Projects</div>
      </div>
      <div className="stat-item" aria-label="Technology Categories">
        <div className="stat-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="42" height="42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 19h16M4 5h16M6 9h12v6H6V9z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="stat-number">8</div>
        <div className="stat-label">Technology Categories</div>
      </div>
      <div className="stat-item" aria-label="Years Average Partnership">
        <div className="stat-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="42" height="42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 21h18M5 21V9l5 3V9l5 3V3h2v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="stat-number">12+</div>
        <div className="stat-label">Years Average Partnership</div>
      </div>
    </div>
  );
};

export default StatisticsBar;
